module.exports = __webpack_public_path__ + "static/media/airline.3429e9f9.svg";